var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-49846629-d9b7-4c39-9bb2-0dad2e72b653",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m25.27,10.144H6.73c-.436,0-.85.189-1.135.52-.285.33-.412.767-.349,1.198l2.401,16.356c.108.736.74,1.282,1.484,1.282h13.738c.744,0,1.376-.546,1.484-1.282l2.401-16.356c.063-.431-.064-.869-.349-1.198-.285-.33-.699-.52-1.135-.52Zm-3.697,16.356h-11.146l-1.961-13.356h15.068l-1.961,13.356Z",
    style: {
      fill: "#e7e7e7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.928,4.756h-6.251v-.274c0-1.093-.889-1.982-1.982-1.982h-3.389c-1.093,0-1.982.889-1.982,1.982v.274h-6.251c-.828,0-1.5.671-1.5,1.5s.672,1.5,1.5,1.5h19.855c.828,0,1.5-.671,1.5-1.5s-.672-1.5-1.5-1.5Z",
    style: {
      fill: "#e7e7e7"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/Trash.f3fff9bf8c2b182753b621a22f5a5d74.svg";
export { ForwardRef as ReactComponent };